import { Box } from '@mui/material';
import { FC } from 'react';
import { companyConfigService } from '../../../services/companyConfig/companyConfig.service';
import { Theme } from '../../../styles/theme/theme';

export const Question: FC<IQuestion> = ({ message }) => {
  const user = companyConfigService.getCachedConfigs()?.currentUser;

  return (
    <Box sx={{ textAlign: 'left', marginBottom: '16px', position: 'relative' }}>
      <Box
        sx={{
          display: 'inline-block',
          padding: '8px 16px 16px',
          borderRadius: '10px',
          background: `rgba(33, 150, 243, 0.12)`,
          wordBreak: 'break-word',
        }}
      >
        <Box
          sx={{
            color: Theme.palette.primary.main,
            fontSize: '14px',
            fontFamily: Theme.typography.fontFamily,
            fontWeight: 600,
            marginBottom: '6px',
          }}
        >
          {user?.name}
        </Box>
        {message as string}
      </Box>
    </Box>
  );
};
export interface IQuestion {
  message: string;
}
